import { useEffect, useState, useRef } from 'react';

const ThinkingLog = ({ thinking, thinkingMessages }) => {
    const [userScrolled, setUserScrolled] = useState(false);
    const thinkingLogRef = useRef(null);
    const isProgrammaticScroll = useRef(false);

    const handleBottomScroll = () => {
        if (thinkingLogRef.current) {
            isProgrammaticScroll.current = true;
            thinkingLogRef.current.scrollTop = thinkingLogRef.current.scrollHeight;
            setTimeout(() => {
                isProgrammaticScroll.current = false;
            }, 50);
        }
    };

    useEffect(() => {
        if (thinkingLogRef.current) {
            const handleScroll = () => {
                if (isProgrammaticScroll.current) {
                    return; // Ignore programmatic scrolls
                }
                
                const threshold = 5; // Allow small threshold for floating point errors
                const isAtBottom = thinkingLogRef.current.scrollHeight - thinkingLogRef.current.scrollTop - thinkingLogRef.current.clientHeight < threshold;
                
                if (isAtBottom) {
                    setUserScrolled(false); // User scrolled back to bottom, resume auto-scroll
                } else {
                    setUserScrolled(true);
                }
            };

            thinkingLogRef.current.addEventListener('scroll', handleScroll);

            return () => thinkingLogRef.current && thinkingLogRef.current.removeEventListener('scroll', handleScroll);
        }
    }, [thinkingLogRef.current]);

    useEffect(() => {
        if (!thinking) {
            setUserScrolled(false);
        }
    }, [thinking]);

    useEffect(() => {
        if (!userScrolled && thinkingLogRef.current) {
            handleBottomScroll();
        }
    }, [thinkingMessages, userScrolled, thinking]);

    // Use MutationObserver to continuously scroll while content changes
    useEffect(() => {
        if (thinking && !userScrolled && thinkingLogRef.current) {
            const observer = new MutationObserver(() => {
                if (!userScrolled) {
                    handleBottomScroll();
                }
            });

            observer.observe(thinkingLogRef.current, {
                childList: true,
                subtree: true,
                characterData: true
            });

            return () => observer.disconnect();
        }
    }, [thinking, userScrolled]);

    return (
        <div id="thinking-log" ref={thinkingLogRef} className="position-fixed end-0 tif-p-20 overflow-auto d-xl-block d-none">
            {
                thinkingMessages.length ?
                    <ul className="list-unstyled">
                        {thinkingMessages.map((msg, index) => (
                            <li key={index} className="tif-color-kilo tif-mb-20">{msg.message}</li>
                        ))}
                    </ul>
                    :
                    null
            }

            {
                thinking ?
                    <div className="thinking-indicator d-flex align-items-center">
                        <svg viewBox="25 25 50 50" className="tif-mr-10">
                            <circle r="20" cy="50" cx="50"></circle>
                        </svg>
                        <p className="shimmer-text tif-color-kilo tif-font-sm tif-mb-0">Thinking...</p>
                    </div>
                    :
                    null
            }
        </div>
    );
};

export default ThinkingLog;